<div class="text-center pt-1">
    <h4 mat-dialog-title>{{ title|translate }}</h4>
    <div mat-dialog-content>
        <mat-spinner [style.margin]="'auto'"></mat-spinner>
    </div>
</div>
